import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DataTable from '../reporting_utils/DataTable';

const $ = window.$;

function AppointmentConversion({ tableData, currentMonth }) {
  const previousMonth = moment(currentMonth)
    .startOf('month')
    .subtract(1, 'months')
    .startOf('month')
    .format('YYYY-MM-DD');

  const currentMonthData = tableData.filter((data) => data.start_date === currentMonth);
  const previousMonthData = tableData.filter((data) => data.start_date === previousMonth);
  const formattedData = currentMonthData.map((data) => {
    const prevData = previousMonthData.find((prev) => prev.user_id === data.user_id);
    if (prevData) {
      return {
        ...data,
        prev_bookable_calls: prevData.bookable_calls,
        prev_appt_calls: prevData.appt_calls,
        prev_appt_conversion_rate: prevData.appt_conversion_rate,
      };
    } else {
      return {
        ...data,
        prev_bookable_calls: null,
        prev_appt_calls: null,
        prev_appt_conversion_rate: null,
      };
    }
  });

  const maxBookablePropsects = Math.max(...formattedData.map((data) => data.bookable_calls));
  const maxSixMonthBookableProspects = Math.max(
    ...formattedData.map((data) => data.prev_bookable_calls)
  );

  const columnDefs = [
    {
      title: 'Current Month',
      children: [
        {
          title: 'Employee',
          render(data, type, row) {
            if (row.first_name && row.last_name) {
              return `${row.first_name} ${row.last_name}`;
            } else {
              return row.email;
            }
          },
        },
        {
          data: 'bookable_calls',
          render: (data) => (data ? data : 0),
          createdCell: (td, cellData) => {
            const percentage = cellData / maxBookablePropsects;
            $(td).css('background-color', `rgba(22, 163, 74, ${percentage})`);
          },
          title: 'Bookable Prospects',
        },
        { data: 'appt_calls', render: (data) => (data ? data : 0), title: 'Appointments' },
        {
          data: 'appt_conversion_rate',
          render: (data, type) => {
            if (type === 'sort') {
              return data;
            } else if (data) {
              return `${data}%`;
            } else {
              return '--';
            }
          },
          title: 'Conversion %',
          type: 'num',
        },
      ],
    },
    {
      title: 'Previous Month',
      children: [
        {
          data: 'prev_bookable_calls',
          render: (data) => (data ? data : 0),
          createdCell: (td, cellData) => {
            const percentage = cellData / maxSixMonthBookableProspects;
            $(td).css('background-color', `rgba(22, 163, 74, ${percentage})`);
          },
          title: 'Bookable Prospects',
        },
        { data: 'prev_appt_calls', render: (data) => (data ? data : 0), title: 'Appointments' },
        {
          data: 'prev_appt_conversion_rate',
          render: (data, type) => {
            if (type === 'sort') {
              return data;
            } else if (data) {
              return `${data}%`;
            } else {
              return '--';
            }
          },
          title: 'Conversion %',
          type: 'num',
        },
      ],
    },
  ];

  return (
    <div>
      <h3 className='text-center'>Employee Breakdown</h3>
      <DataTable
        columnDefs={columnDefs}
        data={formattedData}
        title='Employee Breakdown'
        order={[[1, 'desc']]}
      />
    </div>
  );
}

AppointmentConversion.propTypes = {
  tableData: PropTypes.array.isRequired,
  currentMonth: PropTypes.string.isRequired,
};

export default AppointmentConversion;
